import { render, staticRenderFns } from "./AddPaymentMethod.vue?vue&type=template&id=03c08f70&scoped=true&"
import script from "./AddPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./AddPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./AddPaymentMethod.vue?vue&type=style&index=0&id=03c08f70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c08f70",
  null
  
)

export default component.exports